import KfzEdit from "../components/KfzEdit";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import {createKfz} from "../actions/kfzActions";
import isFunc from 'lodash/isFunction';
import {showSnackbar} from "../actions/snachbarActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_KFZ} from "../actions";
import {ROUTE_KFZ_EDIT} from "../routes";

const m2s = state => ({
	isUpdating: isProcessing(state, PROC_KFZ)
});
const m2d = dispatch => ({
	push: to => dispatch(push(to)),
	onSave: (kfz, onSuccess) => dispatch(createKfz(kfz, result => {
		isFunc(onSuccess) && onSuccess(result);
		dispatch(showSnackbar('snackbar.kfz.created'));
		dispatch(push(ROUTE_KFZ_EDIT.replace(':kfz_id', result.kfz_id)));
	}))
});

export default connect(m2s, m2d)(KfzEdit);


// WEBPACK FOOTER //
// ./src/containers/KfzCreateController.js